module.exports = __webpack_public_path__ + "static/media/jim-crayon.ff3383c0.png";